import React from 'react';

import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { EthocaLogo } from 'minna-ui';
import { useTheme } from '@mui/material/styles';
import styled from '@emotion/styled';
import type { Theme } from '@mui/material';
import { Button } from '@mui/material';
import { DescriptionOutlined } from '@mui/icons-material';
import { AcquisitionBanner } from './AcquisitionBanner';
import { LocaleSwitcher } from '../../app/tickets/LocalizationComponents/example/LocaleSwitcher';
import type { Locale } from '@utils/models';
import { useDispatch, useSelector } from 'react-redux';
import { AppContextActions } from '../../app/localization/duck';
import { useTranslation } from 'react-i18next';
import i18n from '../../app/localization/i18n';

export interface AdminMenuBarProps {
  title: string;
}

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: ${(props: { theme: Theme }) => props.theme.zIndex.drawer + 1};
`;

const RightSide = styled.div`
  display: flex;
  align-items: center;
`;

const AppBarStyled = styled(AppBar)`
  background-color: ${(props: { theme: Theme }) => props.theme.palette.primary.main};
  position: relative; /* Changed from fixed to relative */
`;

const UserGuideButton = styled(Button)`
  margin: 0 10px 0 0;
  text-transform: none;
`;

export const ActionPortalMenuBar: React.FC<AdminMenuBarProps> = ({ title }) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const currentLocale = useSelector((state: any) => state.appContext.locale);
  const { t } = useTranslation('headerFooter', { i18n: i18n });

  const handleSetLocale = (locale: Locale) => {
    dispatch(AppContextActions.setLocale(locale));
  };

  return (
    <HeaderContainer theme={theme}>
      <Box sx={{ flexGrow: 1 }}>
        <AppBarStyled data-testid="menu-bar-top" theme={theme}>
          <Toolbar>
            <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
              {title}
            </Typography>
            <RightSide>
              <UserGuideButton
                variant="contained"
                startIcon={<DescriptionOutlined />}
                href="/docs/Action%20Portal%20Demo%20Document_Guide.pdf"
                // @ts-ignore
                target="_blank"
              >
                {t('user_guide')}
              </UserGuideButton>
              <LocaleSwitcher value={currentLocale} setLocale={handleSetLocale} />
              <EthocaLogo />
            </RightSide>
          </Toolbar>
        </AppBarStyled>
      </Box>
      <AcquisitionBanner />
    </HeaderContainer>
  );
};
